// extracted by mini-css-extract-plugin
export default {"layout":"ce43b2","layout__inner":"df3155","layoutInner":"df3155"};